import React, { useState } from "react";
import AuthLayout, { PasswordField } from "../components/AuthLayout";
import { useHistory } from "react-router-dom";
import { validatePassword } from "../utils/validator";
import { encrypt } from "../utils";
import request from "../core/request";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const history = useHistory();
  const [state, setState] = useState({
    password: "",
    passwordError: "",
    confirmPassword: "",
    confirmPasswordError: "",
    showPassword: false,
  });
  const [loading, setLoading] = useState(false);
  const handleState = (value, key) => {
    setState({ ...state, [key]: value, [key + "Error"]: "" });
  };

  const handleSubmit = async () => {
    let isValid = true;
    let localState = state;
    const passwordValidation = validatePassword(state.password);
    if (!passwordValidation.isValid) {
      isValid = false;
      localState = { ...localState, passwordError: passwordValidation.message };
    }
    const confirmPasswordValidation = validatePassword(state.confirmPassword);
    if (!confirmPasswordValidation.isValid) {
      isValid = false;
      localState = {
        ...localState,
        confirmPasswordError: confirmPasswordValidation.message,
      };
    }

    if (state.password !== state.confirmPassword) {
      isValid = false;
      localState = {
        ...localState,
        confirmPasswordError: `Password does not match!`,
      };
    }
    if (isValid) {
      setLoading(true);
      const params = new URLSearchParams(history.location.search);

      const email = history.location.search.substring(
        history.location.search.indexOf("email=") + 6
      );
      const token = params.get("token");
      const hashedPassword = await encrypt(state.password);
      let { data, status } = await request.put(`/user/resetpassword/${token}`, {
        email: email,
        password: hashedPassword,
      });
      if (status >= 400) {
        if (data?.message?.message) {
          toast.error(data?.message?.message);
        } else {
          toast.error(data.message);
        }
      }
      if (status >= 200 && status < 300) {
        toast.success("Successfully updated the password.");
        history.push("/");
      }
      setLoading(false);
    } else {
      setState(localState);
    }
  };

  return (
    <AuthLayout
      title="Reset password"
      subtitle="Create a new password for your account."
      after={
        <p className="signup-line">
          <button type="button" className="link" onClick={() => history.push("/")}>
            Back to sign in
          </button>
        </p>
      }
    >
      <PasswordField
        id="psw"
        label="New password"
        placeholder="Enter new password"
        autoComplete="new-password"
        value={state.password}
        error={state.passwordError}
        onChange={(value) => handleState(value, "password")}
      />
      <PasswordField
        id="cpsw"
        label="Confirm password"
        placeholder="Confirm new password"
        autoComplete="new-password"
        value={state.confirmPassword}
        error={state.confirmPasswordError}
        onChange={(value) => handleState(value, "confirmPassword")}
      />
      <button
        type="button"
        className="auth-btn auth-btn-primary auth-btn-block"
        disabled={loading}
        onClick={handleSubmit}
      >
        {loading ? "Updating…" : "Update password"}
      </button>
    </AuthLayout>
  );
};

export default ResetPassword;
